(function () {
  'use strict';

  function initBuilder(root) {
    if (root.dataset.bundleInitialized === 'true' || !window.BundleStaffel) return;
    root.dataset.bundleInitialized = 'true';

    var tiers = window.BundleStaffel.tiersFromElement(root);
    var selection = {};
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-filter]'));
    var addButton = root.querySelector('[data-bundle-submit]');
    var status = root.querySelector('[data-bundle-status]');

    root.querySelectorAll('[data-money-cents]').forEach(function (element) {
      element.textContent = window.BundleStaffel.formatMoney(element.getAttribute('data-money-cents'));
    });

    function selectedLines() {
      return Object.keys(selection).map(function (id) {
        return selection[id];
      }).filter(function (line) {
        return line.quantity > 0;
      });
    }

    function totals() {
      return selectedLines().reduce(function (total, line) {
        total.quantity += line.quantity;
        total.subtotalCents += line.quantity * line.priceCents;
        return total;
      }, { quantity: 0, subtotalCents: 0 });
    }

    function announce(message) {
      if (status) status.textContent = message;
    }

    function render() {
      var total = totals();
      var result = window.BundleStaffel.calculate(total.quantity, total.subtotalCents, tiers);

      root.querySelectorAll('[data-bundle-tier]').forEach(function (tierElement) {
        var minimum = parseInt(tierElement.getAttribute('data-minimum'), 10);
        tierElement.classList.toggle('is-reached', Boolean(result.current && result.current.minimum === minimum));
      });

      cards.forEach(function (card) {
        var productId = card.getAttribute('data-product-id');
        var productQuantity = Object.keys(selection).reduce(function (quantity, id) {
          return quantity + (selection[id].productId === productId ? selection[id].quantity : 0);
        }, 0);
        card.classList.toggle('is-selected', productQuantity > 0);
        var quantityElement = card.querySelector('[data-product-quantity]');
        if (quantityElement) quantityElement.textContent = productQuantity;
        var control = card.querySelector('[data-quantity-control]');
        var trigger = card.querySelector('[data-add-trigger]');
        if (control) control.hidden = productQuantity === 0;
        if (trigger) trigger.hidden = productQuantity > 0;
      });

      var hint = root.querySelector('[data-bundle-hint]');
      var count = root.querySelector('[data-bundle-count]');
      var level = root.querySelector('[data-bundle-level]');
      var original = root.querySelector('[data-bundle-original]');
      var preview = root.querySelector('[data-bundle-preview]');
      var previewCode = root.querySelector('[data-bundle-preview-code]');

      if (hint) hint.textContent = window.BundleStaffel.message(result);
      if (count) count.textContent = total.quantity + (total.quantity === 1 ? ' ARTIKEL' : ' ARTIKEL');
      if (level) level.textContent = result.currentPercent ? result.currentPercent + ' % RABATT' : 'NOCH KEIN RABATT';
      if (original) {
        original.textContent = window.BundleStaffel.formatMoney(total.subtotalCents);
        original.hidden = result.currentPercent === 0;
      }
      if (preview) preview.textContent = window.BundleStaffel.formatMoney(result.previewCents);
      if (previewCode) {
        previewCode.textContent = result.current ? 'mit Code ' + window.BundleStaffel.codeForTier(result.current) : '';
        previewCode.hidden = !result.current;
      }
      if (addButton) addButton.disabled = total.quantity === 0;
    }

    function addVariant(card, variantButton) {
      var id = variantButton.getAttribute('data-variant-id');
      if (!id || variantButton.disabled) return;
      if (!selection[id]) {
        selection[id] = {
          id: Number(id),
          productId: card.getAttribute('data-product-id'),
          priceCents: Number(variantButton.getAttribute('data-variant-price')),
          quantity: 0
        };
      }
      selection[id].quantity += 1;
      card.dataset.activeVariant = id;
      var chooser = card.querySelector('[data-variant-chooser]');
      if (chooser) chooser.hidden = true;
      announce('Produkt hinzugefügt.');
      render();
    }

    function changeProductQuantity(card, delta) {
      var productId = card.getAttribute('data-product-id');
      var matching = Object.keys(selection).filter(function (id) {
        return selection[id].productId === productId && selection[id].quantity > 0;
      });
      if (delta > 0) {
        var active = card.dataset.activeVariant || matching[matching.length - 1];
        var button = card.querySelector('[data-variant-id="' + active + '"]');
        if (button) addVariant(card, button);
        return;
      }
      var last = matching[matching.length - 1];
      if (!last) return;
      selection[last].quantity -= 1;
      if (selection[last].quantity <= 0) delete selection[last];
      announce('Menge aktualisiert.');
      render();
    }

    root.addEventListener('click', function (event) {
      var filter = event.target.closest('[data-bundle-filter]');
      if (filter) {
        var category = filter.getAttribute('data-bundle-filter');
        filterButtons.forEach(function (button) {
          var active = button === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          card.hidden = category !== 'alle' && card.getAttribute('data-category') !== category;
        });
        return;
      }

      var trigger = event.target.closest('[data-add-trigger]');
      if (trigger) {
        var triggerCard = trigger.closest('[data-bundle-card]');
        var variants = triggerCard.querySelectorAll('[data-variant-id]');
        if (variants.length === 1) {
          addVariant(triggerCard, variants[0]);
        } else {
          var chooser = triggerCard.querySelector('[data-variant-chooser]');
          if (chooser) {
            chooser.hidden = !chooser.hidden;
            if (!chooser.hidden) {
              var firstAvailable = chooser.querySelector('[data-variant-id]:not([disabled])');
              if (firstAvailable) firstAvailable.focus();
            }
          }
        }
        return;
      }

      var variant = event.target.closest('[data-variant-id]');
      if (variant) {
        addVariant(variant.closest('[data-bundle-card]'), variant);
        return;
      }

      var quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) {
        changeProductQuantity(
          quantityButton.closest('[data-bundle-card]'),
          Number(quantityButton.getAttribute('data-quantity-change'))
        );
      }
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var lines = selectedLines();
        if (!lines.length || addButton.disabled) return;
        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        announce('Produkte werden hinzugefügt.');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: lines.map(function (line) {
              return { id: line.id, quantity: line.quantity };
            })
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart_add_failed');
            return response.json();
          })
          .then(function () {
            selection = {};
            render();
            announce('Produkte wurden hinzugefügt.');
            if (window.oneACartDrawer && typeof window.oneACartDrawer.open === 'function') {
              window.oneACartDrawer.open();
            } else {
              window._cd1aPending = true;
            }
          })
          .catch(function () {
            announce('Das Hinzufügen hat nicht geklappt. Bitte erneut versuchen.');
          })
          .then(function () {
            addButton.removeAttribute('aria-busy');
            render();
          });
      });
    }

    render();
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-bundle-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
